import axios from 'axios';
import rateLimit from 'axios-rate-limit';

const instance = rateLimit(axios.create(), { maxRequests: 5, perMilliseconds: 4000 });

export default instance;
